export interface contentItem {
    src_text: string;
    translated_text: string;
    graph_index: number;
}

export interface ApiGetTranslationAsyncStatusResponse {
    task_id: string;
    status: string;
    content: contentItem[];
}

export const GetTranslationAsyncStatus = Symbol('GetTranslationAsyncStatus');

export interface GetTranslationAsyncStatus {
    getTranslationAsyncStatus(taskId: string): Promise<ApiGetTranslationAsyncStatusResponse>;
}